

import store from '../store'
import Request from './request'
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

async function fetch(data){
    return Request("get","api/receipt",data)
}

async function fetchOne(id,data){
    return Request("get","api/receipt/" + id,data)
}

// 对账
async function checkBill(id){
    return Request("get","api/receipt/check-bill/" + id)
}

// 解除对账
async function unCheckBill(id){
    return Request("get","api/receipt/uncheck-bill/" + id)
}
// 对账备注更新
async function CheckBillMemoUpdate(id,data){
    return Request("post", "api/receipt/update/" + id, data)
}   

// 添加收付款
async function saveBillRecord(data){
    return Request("post","api/receipt/save-bill-record/",data)
}

// 红冲
async function offSetting(data){
    return Request("post","api/receipt/offsetting/",data)
}

// 退款
async function refund(data){
    return Request("post","api/receipt/refund/",data)
}

// 归账
async function complete(id){
    return Request("get","api/receipt/complete/" + id)
}

// 更新凭证类型
async function refresh(data){
    return Request("get","api/receipt/update-credential-type",data)
}

// 导出excel
async function exportExcel(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

// 批量导出
async function exportBatchExcel(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/batch-detail-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

// 对账单详情下载
async function download(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/detail-export?" , data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

//要货单付款明细下载
async function orderBillRecordsExport(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/order-bill-records-export?" , data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

// 应收详情下载
async function subAccountReceivableDetailExport(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/sub-account-receivable-detail-export" , data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

//要货对账单下载
async function resourceOrderExport(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/resource-order-export?" , data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}
//采购对账单下载
async function supplierOrderExport(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/supplier-order-export?" , data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}
//退款对账单下载
async function resourceReturnOrderExport(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/resource-return-order-export?" , data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function getBatchBill(data){
    return Request("get","api/receipt/get-batch-bill-info",data)
}

// 收付款历史导出
async function historyExport(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/receipt/history-export', data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

// 要货对账单支付详情导出
async function resourceOrderPaymentExport(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/receipt/resource-order-payment-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function getAvailablePayTypes() {
    return Request("get","api/receipt/get-available-pay-types")
}

// 批量导出分账明细
async function historySubAccountDetailsExport(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/receipt/history-sub-account-details-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function getAutoMemo(code, data) {
    if (!data) data = {};
    return Request("get", "api/receipt/get-auto-memo/" + code, data)
}

async function getRefundFee(data){
    return Request("post", "api/receipt/get-refund-fee", data)
}

async function batchCheckBill(data) {
    //批量对账
    return Request('get', 'api/receipt/batch-check-bill', data, false, false, true)
}

async function batchUncheckBill(data) {
    //批量解除对账
    return Request('get', 'api/receipt/batch-uncheck-bill', data, false, false, true)
}

async function lklSubAccountCancelRefund(data) {
    //拉卡拉分账作废账单退款
    return Request('post', 'api/receipt/lkl-sub-account-cancel-refund', data)
}

async function uploadImg(data) {
    //上传流水附件
    return Request('post', 'api/receipt/upload_img', data)
}

async function getRelations(id){
    return Request("get","api/receipt/relations/" + id)
}


export default {
    fetch,
    checkBill,
    unCheckBill,
    fetchOne,
    saveBillRecord,
    offSetting,
    refund,
    complete,
    refresh,
    exportExcel,
    exportBatchExcel,
    download,
    getBatchBill,
    orderBillRecordsExport,
    subAccountReceivableDetailExport,
    historyExport,
    resourceOrderExport,
    supplierOrderExport,
    resourceReturnOrderExport,
    getAvailablePayTypes,
    resourceOrderPaymentExport,
    historySubAccountDetailsExport,
    getAutoMemo,
    getRefundFee,
    CheckBillMemoUpdate,
    batchCheckBill,
    batchUncheckBill,
    lklSubAccountCancelRefund,
    uploadImg,
    getRelations,
}